import { render, staticRenderFns } from "./InvoiceFields.vue?vue&type=template&id=16842713&lang=pug&"
import script from "./InvoiceFields.vue?vue&type=script&lang=ts&"
export * from "./InvoiceFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports